import DZModelPage from "@/model/DZModelPage";

class DZSearchLand extends DZModelPage{

    /**
     * 区域ID
     */
    county = "";

    countyArr = [];

    /**
     * 区域等级
      */
    level = ""

    /**
     * 土地类型：1-农业用地，2-建设用地
     */
    type = "";

    /**
     * 流转类型ID
     */
    moverType = "";

    /**
     * 标签
     */
    label = "";

    /**
     * 关键字
     */
    key = "";

    /**
     * 发布状态：0-待审核，1-待交易，2-审核未通过，3-暂停，4-已过期，5-已交易
     */
    status = "";

    bigType = "";
    smallType = "";
}
export default DZSearchLand;
